import { THEME_REALDANIA, THEME_UNDERVAERKER, THEME_JUBILAEUM } from '../themes';
import { getQuery } from './query';

export default {
  provide() {
    return {
      referrer: () => this.referrer,
      isReferrer: (val) => this.referrer === val.toUpperCase(),
    };
  },
  data() {
    return {
      route: null,
      referrer: THEME_REALDANIA,
    };
  },
  computed: {
    layout() {
      if (!this.route || this.route.layout === null || this.route.layout === undefined) {
        return 'div';
      }

      const hasLayoutDefined = Object.keys(this.route.layout).length;

      if (hasLayoutDefined === 0) {
        return this.route.layout;
      }

      return this.route.layout[this.referrer];
    },
  },
  mounted() {
    this.detectRoute();
  },
  methods: {
    detectRoute() {
      const exists = this.routes.filter((route) => route.pathname === location.pathname.toLowerCase());
      if (exists.length > 0) {
        this.route = exists[0];
      }
    },
  },
};
